import { Injectable } from '@angular/core';

import { Buffer } from 'buffer';
import FileSaver from 'file-saver';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class FileActionService {

  browserPreview(fileData: string) {
    const buff = Buffer.from(fileData, 'base64');
    const blob = new Blob([buff], { type: 'application/pdf' });
    const blobURL = URL.createObjectURL(blob);
    window.open(blobURL);
  }

  browserSave(fileName: string, fileData: string) {
    const buff = Buffer.from(fileData, 'base64');
    const blob = new Blob([buff], { type: 'application/pdf' });
    FileSaver.saveAs(blob, `${this.getFileName(fileName)}`);
  }

  getFileName(fileName: string) {
    const date = new Date();
    const formatedDate = moment(date).format('YYYY-MM-DD_HH-mm-ss');
    return `${fileName}_${formatedDate}.pdf`;
  }
}
